import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const EquipmentUtilization = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/analytics/equipment-utilization');
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching equipment utilization:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading equipment utilization...</div>;

  return (
    <div className="equipment-utilization">
      <div className="card">
        <h3>Equipment Utilization by Element</h3>
        {data.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Element</th>
                <th>Category</th>
                <th>Total CY</th>
                <th>Equipment Hours</th>
                <th>Hours/CY</th>
                <th>Equipment Types</th>
                <th>Log Count</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.element_detail}</td>
                  <td>{item.element_category}</td>
                  <td>{item.total_cubic_yards}</td>
                  <td>{item.total_equipment_hours}</td>
                  <td><strong>{item.equipment_hours_per_cy}</strong></td>
                  <td>{item.equipment_types.join(', ')}</td>
                  <td>{item.log_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No equipment utilization data available yet.</p>
        )}
      </div>
    </div>
  );
};

export default EquipmentUtilization;